import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    Box,
    Typography,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormHelperText,
    Button,
    TextField
} from '@mui/material';

const NeedsSection = ({ onNext }) => {
    const { control, handleSubmit, watch, formState: { errors } } = useForm({
        defaultValues: {
            potrzeby_wybrane: [],
            potrzeby_dodatkowe_mysli: ''
        }
    });

    const needsOptions = [
        "Bezpieczeństwa finansowego",
        "Wytchnienia i spokoju",
        "Ruchu",
        "Wolności i niezależności",
        "Wybierania własnych planów, celów i marzeń",
        "Podążania za własnymi wartościami",
        "Samorealizacji i rozwoju",
        "Kreatywności",
        "Wyzwań",
        "Sensu, celu i spełnienia",
        "Poczucia sprawczości",
        "Równowagi i harmonii",
        "Uznania i szacunku",
        "Poczucia przynależności do grupy",
        "Kontaktu z innymi",
        "Odpowiedzialności",
        "Szczęścia",
        "Różnorodności i urozmaicenia"
    ];

    const selectedNeeds = watch('potrzeby_wybrane', []);

    const validateNeeds = (value) => {
        if (!value || value.length < 3) {
            return "Proszę wybrać minimum 3 potrzeby";
        }
        if (value.length > 5) {
            return "Można wybrać maksymalnie 5 potrzeb";
        }
        return true;
    };

    return (
        <Box component="form" onSubmit={handleSubmit(onNext)} sx={{ mt: 3 }}>
            <Typography variant="body1" color="blue" sx={{ mb: 3 }} component="div">
                Potrzeby są nieodłącznym elementem naszego życia. To one napędzają działania, decyzje i emocje.
                Zrozumienie własnych potrzeb to klucz do budowania satysfakcjonujących relacji i osiągania celów.
                <br />
                <b>Rodzaje potrzeb</b>
                <br />
                Potrzeby można podzielić na kilka kategorii:
                <ul>
                    <li><b>Fizyczne:</b> Potrzeby związane z przetrwaniem i utrzymaniem zdrowia, takie jak jedzenie, sen, schronienie, aktywność fizyczna.</li>
                    <li><b>Emocjonalne:</b> Potrzeby związane z odczuwaniem i wyrażaniem emocji, takie jak miłość, akceptacja, bezpieczeństwo, poczucie własnej wartości.</li>
                    <li><b>Społeczne:</b> Potrzeby związane z relacjami z innymi ludźmi, takie jak przynależność, wsparcie, bliskość.</li>
                    <li><b>Duchowe:</b> Potrzeby związane z poszukiwaniem sensu życia, wartości, celu.</li>
                </ul>
                <br />
                <b>Znaczenie świadomości potrzeb</b>
                <br />
                Świadomość potrzeb to umiejętność rozpoznawania i nazywania tego, czego potrzebujemy. To kluczowy element rozwoju osobistego i budowania satysfakcji. Kiedy jesteśmy świadomi swoich potrzeb, możemy lepiej zaspokoić je w sposób, który jest dla nas korzystny.
                Warto poświęcić czas na zastanowienie się, czego naprawdę potrzebujemy i jak możemy zaspokoić te potrzeby w sposób, który jest dla nas najkorzystniejszy.
            </Typography>

            <FormControl
                component="fieldset"
                error={!!errors.potrzeby_wybrane}
                sx={{ mb: 3 }}
                fullWidth
            >
                <FormLabel component="legend">
                    <Typography variant="h6" color="black">
                        Zaznacz 5 najważniejszych potrzeb, jakie powinna zaspokajać Twoja praca:
                    </Typography>
                </FormLabel>
                <Controller
                    name="potrzeby_wybrane"
                    control={control}
                    rules={{ validate: validateNeeds }}
                    render={({ field }) => (
                        <FormGroup
                            style={{
                                'display': 'grid',
                                'gridTemplateColumns': 'repeat(2, 1fr)'
                            }}
                        >
                            {
                                needsOptions.map((option) => (
                                    <FormControlLabel
                                        key={option}
                                        control={
                                            <Checkbox
                                                checked={field.value.includes(option)}
                                                onChange={(e) => {
                                                    if (field.value.length < 5 || field.value.includes(option)) {
                                                        const newValue = e.target.checked
                                                            ? [...field.value, option]
                                                            : field.value.filter(val => val !== option);
                                                        field.onChange(newValue);
                                                    }
                                                }}
                                            />
                                        }
                                        label={option}
                                    />
                                ))
                            }
                        </FormGroup>
                    )}
                />
                {errors.potrzeby_wybrane && (
                    <FormHelperText>{errors.potrzeby_wybrane.message}</FormHelperText>
                )}
            </FormControl>
            {/* 
            <Controller
                name="potrzeby_dodatkowe_mysli"
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        fullWidth
                        multiline
                        rows={4}
                        label="Dodatkowe przemyślenia dotyczące Twoich potrzeb (opcjonalne)"
                        sx={{ mb: 3 }}
                    />
                )}
            /> */}

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={selectedNeeds.length < 3 || selectedNeeds.length > 5}
            >
                Dalej
            </Button>
        </Box >
    );
};

export default NeedsSection; 